import { ICO_INQUIRY_EMAIL } from "@common/constants";
import { useTranslation } from "next-i18next";
import TextLink from "@common/components/TextLink";
import { Event as HotjarEvent, hotjar } from "@modules/core/hotjar/types";
import { gtmPushData } from "@talladega/helpers";
import { ModalProps, Modal } from "@talladega/components";

type Props = Pick<ModalProps, "isOpen" | "onClose">;

const DealCreatedForOfferModal = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation(["common", "purchase", "tradeInPage"]);

  const handleOnClose = () => {
    gtmPushData({
      event: "ICO In Progress Modal",
      description: "ICO In Progress Modal Close",
      element: "Close",
    });

    hotjar.event(HotjarEvent.IcoInProgressModalClose);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnClose}
      title={t("common:instant_cash_offer")}
      alignment="center"
    >
      <div className="md:w-96 mx-auto">
        <p className="mb-4 text-primary text-xl font-semibold">
          {t("purchase:your_offer_in_progress")}
        </p>
        <p className="pb-6 text-secondary text-lg font-normal">
          {t("purchase:offer_processed_by_buying_team")}
        </p>
        <p className="text-lg font-normal mt-1 text-secondary">
          {t("purchase:contact_us_offer_questions")}
        </p>
        <TextLink
          className="text-brand-tertiary"
          href={`mailto:${ICO_INQUIRY_EMAIL}`}
        >
          <a>{ICO_INQUIRY_EMAIL}</a>
        </TextLink>
      </div>

      <Modal.Buttons
        isPrimarySubmit
        primaryButtonText={t("common:contact_us")}
        onPrimaryClick={() => {
          gtmPushData({
            event: "ICO In Progress Modal",
            description: "ICO In Progress Modal Contact Us",
            element: "Contact Us",
          });
          hotjar.event(HotjarEvent.IcoInProgressModalContactUsClicked);

          window.location.href = `mailto:${ICO_INQUIRY_EMAIL}`;
          onClose();
        }}
        onSecondaryClick={() => {
          gtmPushData({
            event: "ICO In Progress Modal",
            description: "ICO In Progress Modal Cancel",
            element: "Cancel",
          });
          hotjar.event(HotjarEvent.IcoInProgressModalCancelClicked);

          onClose();
        }}
        secondaryButtonText={t("common:cancel")}
        secondaryButtonFill="link"
      />
    </Modal>
  );
};

export default DealCreatedForOfferModal;
